// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1jRYl","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__DA5BP"};